(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ppb-collection-filter"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change',(event)=>{if(event.target.matches('[data-ppb-sort]'))event.target.form.requestSubmit();});
  } catch(e) { console.error(e); }
})();

})();
